import React from 'react';

export default function HistorySparkline({ history = [] }) {
  if (history.length < 2) return null;
  const width = 240;
  const height = 50;
  const padding = 6;

  // Render progression left-to-right (chronological)
  const sortedHistory = [...history].reverse();
  const points = sortedHistory.map((h, i) => {
    const x = padding + (i * (width - padding * 2)) / (sortedHistory.length - 1);
    const val = h.overall_score || h.score || 0;
    const y = height - padding - (val * (height - padding * 2)) / 100;
    return `${x},${y}`;
  });

  const pathD = `M ${points.join(' L ')}`;

  return (
    <div className="flex flex-col items-center gap-2">
      <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible">
        <defs>
          <linearGradient id="chartGlow" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--brand)" stopOpacity="0.2" />
            <stop offset="100%" stopColor="var(--brand)" stopOpacity="0.0" />
          </linearGradient>
        </defs>
        
        {/* Glow fill underneath path */}
        {points.length > 0 && (
          <path
            d={`${pathD} L ${points[points.length-1].split(',')[0]},${height-padding} L ${points[0].split(',')[0]},${height-padding} Z`}
            fill="url(#chartGlow)"
          />
        )}

        {/* Line path */}
        <path
          d={pathD}
          fill="none"
          stroke="var(--brand)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Circular indicators */}
        {points.map((p, idx) => {
          const [cxVal, cyVal] = p.split(',');
          return (
            <circle
              key={idx}
              cx={cxVal}
              cy={cyVal}
              r={3}
              fill="var(--brand)"
              className="stroke-zinc-950 stroke-[1.5]"
            />
          );
        })}
      </svg>
    </div>
  );
}
